import React, { useEffect, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Download } from 'lucide-react';
interface DataSheetModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
  title?: string;
}
export function DataSheetModal({
  isOpen,
  onClose,
  imageUrl,
  title = 'Data Sheet'
}: DataSheetModalProps) {
  // Prevent scrolling when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = `${title.replace(/\s+/g, '-').toLowerCase()}.png`;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return <AnimatePresence data-id="element-79">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-slate-900/70 backdrop-blur-sm z-[60]" data-id="element-80" />

          {/* Modal Container */}
          <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 sm:p-6 pointer-events-none" data-id="element-81">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2,
          ease: 'easeOut'
        }} className="w-full max-w-4xl bg-white rounded-2xl shadow-2xl overflow-hidden pointer-events-auto flex flex-col max-h-[95vh]" data-id="element-82">
              {/* Header */}
              <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between bg-slate-50/50 flex-shrink-0" data-id="element-83">
                <h2 className="text-lg font-bold text-[#0A1628]" data-id="element-84">{title}</h2>
                <div className="flex items-center gap-2" data-id="element-85">
                  <button onClick={handleDownload} className="flex items-center gap-2 px-4 py-2 bg-[#0052CC] text-white text-sm font-semibold rounded-full hover:bg-[#0040A0] transition-colors" data-id="element-86">
                    <Download className="h-4 w-4" data-id="element-87" />
                    Download
                  </button>
                  <button onClick={onClose} className="p-2 text-slate-400 hover:text-[#0A1628] hover:bg-slate-100 rounded-full transition-colors" aria-label="Close modal" data-id="element-88">
                    <X className="h-5 w-5" data-id="element-89" />
                  </button>
                </div>
              </div>

              {/* Content - Scrollable image */}
              <div className="p-4 overflow-y-auto bg-slate-100" data-id="element-90">
                <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-91">
                  <img src={imageUrl} alt={title} className="w-full h-auto" data-id="element-92" />
                </div>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}